import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router'
import { MatSnackBar } from '@angular/material';
import { CommonService } from '../../services/common.service';
import { AdoptionService } from '../../services/adoption.service';
@Component({
  selector: 'app-adoptionhistory',
  templateUrl: './adoptionhistory.component.html',
  styleUrls: ['./adoptionhistory.component.css']
})
export class AdoptionhistoryComponent implements OnInit {
  contactno: any;
  loading: boolean;
  uid: any;
  myadoption= [];
  found = 1;
  constructor(private router: Router, private commonService: CommonService,
     private snackbar: MatSnackBar , private adoptionService: AdoptionService) {
    const udata = this.commonService.getUserDataLocally();
    this.uid = udata.uid;
   }

  ngOnInit() {
    this.loading = true;
    this.getMyAdoptionPost();
  }
  getMyAdoptionPost() {
    this.adoptionService.getMyAdoptionList(this.uid)
    .subscribe(
      (x) => {
        this.loading = false;
        this.myadoption = x;
        if (this.myadoption && this.myadoption.length > 0) {
          this.found = 1;
        } else {
          this.found = 0 ;
        }
      }
    );
  }
  getContact( uid, pid) {
    this.adoptionService.getPostContact(uid)
    .subscribe(
      (x) => {
        this.contactno['id' + pid] = x.mobile;
        //this.createAdoptionRequest(pid);
      }
    );
}
}
